/**
 * Simple click dropdown -- extendable -- cleanup put class dropdown on element.
 * .dropdown, .dropdown-menu -- classes
 * For select: change return the text value and and object of the assoc data prop.
 * Really anything that pops up --- can be a 'selectmenu'.
 * For now .mi class is what distinguishes from drop down -- can also be dd without select --
 * change also to allow data-close (eg close buttons on dialog).
 * Note: if want to use iframe shim, must be on $.fn ( this now requires iframe shim.
 * Update 3/24/20 --- this is extremely old and requires a lot of cleanup.  When initially written,
 * requires a custom plugin for various reasons; with current requirements maybe time to switch to an
 * existing one.  Lots of quick hacks have been implemented over the years and this have grown
 * more and more application specific.
 */


(function($, Mousetrap, _) {

    $.fn.dropDown = function(options) {

        var settings = {
            content: '', // html markup or jq object
            eventTrigger: 'click', // click OR 'mouseover'; may want to consider custom; TODO: I don't think mouseover still working
            container: 'body', // Don't need if settings.content is a jQuery object -- will use the existing hidden element -- otherwise markup appended to it
            isSelect: false,
            selectNoOpenerText: false, //if a select w/out a box at the top
            hPos: 'left', //default (left or right),
            activeClass: 'active',   //note: can be more than one,
            dropUp: false,
            isSelectForceChangeOnClick: false,
            // maxWidth: provide a max width for the opener (and correspondingly the dropdown content);
            // pixel value as an integer (200) or string '200px';
            // now only applicable to 'isSelect'
            maxWidth: null
        };


        if (options)
            $.extend(settings, options);


        var $opener = $(this),
            $win = $(window),
            openEvent = settings.eventTrigger,
            closeEvent = openEvent === 'click' ? 'click' : 'mouseout',
            $dd = ddContent(),
            $subMenubars = $dd.find('.mi.dropdown-submenu'),
            hasSubMenubars = $subMenubars.length > 0,
            applyIframeShim = settings.applyIframeShim && $.fn.iframeShim,

            position = function() {
                var openerOffset = $opener.offset();
                $dd.css({
                    top: !settings.dropUp
                        ? openerOffset.top + $opener.outerHeight() -1 - $win.scrollTop()
                        : openerOffset.top  - getDDHeight() - $win.scrollTop() - 1,
                    left: settings.hPos === 'left'
                        ? openerOffset.left - $win.scrollLeft()
                        : openerOffset.left - $win.scrollLeft() + $opener.outerWidth() - getDDWidth() //note: recalc the ddwidth b/c if was appended to dom on render, will be 0
                });
            },
            open = function() {

                if (options.onBeforeOpen)
                    options.onBeforeOpen();

                $opener.data('is-open', 'true');

                position();
                $dd.removeClass('hide').addClass('open');
                applyIframeShim && $dd.iframeShim();
                $opener.addClass( settings.activeClass );

                /**
                 * Post left aligned sub-menus.
                 * Could cache.
                 * Done on open so will be visible ( and can calc width )
                 */
                if (settings.isSelect || settings.ddNoSelect) {
                    $dd.find('.sm-left').each(function() {
                        $(this).css('margin-left', -1 * $(this).outerWidth() );
                    });
                }

                setHandlersPostEnter();

                // Maybe only if 'is-current' ??
                if ( options.onOpen )
                    options.onOpen() ;
            },

            // TODO: prevent mem leak in first place -- temp fix for selecting new doc for dropdown when others are closed by still have refs ???
            close = function() {

                if (!$opener)
                    return false;

                // Don't close the current one when closing all before an open
                // *** If rid, looks like can't close the current by clicking on the opener ***
                if ( $opener.data('is-current') ) {
                    return;
                }

                // Provide a hook into taking an action before the 'close' action is taken
                if (options.onBeforeClose) {
                    options.onBeforeClose();
                }

                $opener.removeData('is-open');

                if (applyIframeShim)
                    $dd.iframeShim('destroy');

                $dd.removeClass('open')
                    .addClass('hide');

                $opener.removeClass(settings.activeClass);

                destroyOpenListeners();

                if (settings.isSelect)
                    $opener.removeClass('open');//* note: could used open selector to close all others

                $dd.off(openEvent, dropDownClick);

                Mousetrap.unbind('escape', close);

                if ( hasSubMenubars )
                    closeSubMenus();

                // Note: onClose hook is really like onAfterClose
                if (options.onClose)
                    options.onClose();

            },

            /**
             * When dropdown element is clicked -- for menus (not options.isNotMenu)
             * TODO: clean up logic for closing dialog -- now using the 'select' params
             */
            dropDownClick = function(e) {

                // If target is a menu item allow it to close; otherwise clicks will leave it open --
                // will also allow the click event to propagate to another handler.
                if ( !settings.isSelect && !options.ddNoSelect )
                    return false;

                //Allow to capture clicks from html elements within '.mi tags'
                var $target = $(e.target).closest('.mi');

                if ($target.hasClass('disabled'))  // Note: N/A for contentDDView
                    return false;

                if (settings.isSelect) {

                      // TODO: allow option to trigger change even if same 'text' value selected
                      // -- prob should store id data of the opener as well as the text ...
                      // ... misleading b/c the menu item changes as well ... otherwise s/b in if clause
                      // ... quick fix now is isSelectForceChangeOnClick

                    $dd.find('.mi').removeClass('active');
                    $target.addClass('active');

                    // Allow onchange if noOpenerText
                    if ($opener.find('.ddValue').text() !== $target.text() || settings.isSelectForceChangeOnClick || settings.selectNoOpenerText) {

                        if (!settings.selectNoOpenerText)
                            $opener.find('.ddValue').text($target.text());

                        if (options.onChange)
                            options.onChange.call( $opener, $target.text(), $target.data() ) ;  //pass back the selected item and any data attr of it
                    }

                    close();

                } else if (options.ddMultiSelect) {  //same as select -- but can choose mult options in the dd -- and returns each active

                    var $targetGrp = $target.closest('.dd-grp');
                    $targetGrp.find('.mi').removeClass('active');
                    $target.addClass('active');

                    var $selectedOpts = $dd.find('.mi.active');

                    if (options.onChange) {
                        options.onChange.call( //return array of (data-attr: value) -- like the opt and value from select
                            $opener,
                            _.map($selectedOpts, function(m) {
                                return {
                                    value: $(m).text(),
                                    group:  _.keys($(m).data())[0],
                                    groupVal: _.values($(m).data())[0]
                                };
                            })  //sloppy for time being: give the data-attr value
                        );
                    }

                    close();

                 // Menubar - no select
                } else if (options.ddNoSelect) {

                    if (options.onChange)
                        options.onChange.call( $opener, $target.text(), $target.data() );

                    close();
                }
            },

            setHandlersPostEnter = function() {

                $opener.on( closeEvent, close );

                $('body').on('click', close);

                $win
                    .on('resize', position)
                    .on('scroll', close); //latter (b/c taking window scroll into account

                // Don't pick up click: allow orig handle to target !
                !options.isNotMenu && $dd.on('click', dropDownClick);  // Note: only set on dropDown contentMenu where events delegated to the view
                Mousetrap.bind('escape', close);

            },

            destroyOpenListeners = function() {

                $opener.off( openEvent, open );

                $('body').off('click', close);

                $dd.off('click', dropDownClick);

                $opener.off('close', close); // where set on the opener?

                $win
                    .off('resize', position)
                    .off('scroll', close);

            };



        if ( options.defaultSelector )
            $dd.find( options.defaultSelector ).addClass('active');

        // Temp fix: a way to identify the drowpdown (uses id)
        if (options.id)
            $dd.attr('id', options.id);

        if (options.ddClass)
            $dd.attr('class', options.ddClass);


        var ddWidth = getDDWidth();

        //if (settings.hPos === 'right')
        //  _.extend(settings, {  menuWidth: ddWidth }); note: no longer using -- calc on open (should be in DOM)


        // if select and width of dd < opener , make opener wider
        // if select and change the opener value on select, ensure width is as width as the dropdown
        if (settings.isSelect && !options.selectNoOpenerText)
            $opener.outerWidth(ddWidth);


        if (settings.maxWidth && settings.isSelect)
            applyMaxWidthToSelectDropdown();

        // TODO: can still make invalid selection
        if (settings.isSelect || settings.ddNoSelect)
            $dd.unselectable();


        $dd.on( 'close', close ); // for closing others

        $opener.on( openEvent, function(e) {

            /**
             *  Don't allow to click to hit body.
             *  Would want to just stopPropgation but other handlers are put on the element in this process,
             *  and not using stopImmediatePropagation will break this.
             *  see console.log( $._data( $opener[0], 'events' ) );
             *  Click event is added each time clicked ( probably the 'off' ).
             *  Should change but we need a refactor anyway, so not worth the effort.
             */
            e.stopImmediatePropagation();


            // Set flag for close trigger -- to not close this one
            $opener.data('is-current', true);

            // Close any others that are open
            // issue is that this still does close this one ....even though not selected ....
            // the event will still be broadcast here to this -- seems to be closing this (even though not broadcast)
            // Update: this is working, but maybe it includes both dropdown and dropdown menu ???

            $('.dropdown, .dropdown-menu').not( this ).trigger('close');

            if ( $opener.hasClass('disabled') )
                return false;

            $opener.removeData('is-current');

            $opener.data('is-open')
                ? close(e)
                : open(e);

        });

        /**
         * Contol sub-menu's not via css-hover due to need to iframe-shim them.
         * Compromise implementation -- still have the menu markup positioned adjacent to the menu items.
         * This is all hacky ... fix when clean up entire use of plugin ... only used in app in hover menu.
         * This is working without closing the submenu when the mouse hover's off its parent item ... just go with it
         */
        if (hasSubMenubars) {

            $subMenubars.on('mouseenter mouseleave', function(e) {

                var $subMenuItem = $(e.currentTarget);
                if (e.type === 'mouseenter') {
                    !$subMenuItem.hasClass('disabled') && openSubMenu($subMenuItem);
                } else {
                    closeSubMenu($subMenuItem);
                }

            });
        }


        function closeSubMenus() {
            $subMenubars.each(function() {
                 closeSubMenu($(this));
            });
        }

        function openSubMenu($subMenuBar) {
            var $submenu = $subMenuBar.find('.dropdown-menu');
            $submenu.css({display: 'block'});
             /* (note: element must first be visible to calc position) for shim */
            applyIframeShim && $submenu.iframeShim();
        }

        function closeSubMenu($subMenuBar) {
            var $submenu = $subMenuBar.find('.dropdown-menu');
            $submenu.css({display: 'none'});
            applyIframeShim && $submenu.iframeShim('destroy');
        }

        function ddContent() {

            var $content = settings.content.jquery
                ? settings.content //if jquery -- keep events, etc ( assumes already embedded on container )
                : $(settings.content).appendTo( settings.container ); // html markup -- not on container

            !$content.hasClass('dropdown-menu') &&
                $content.addClass('dropdown-menu');

            // Always add the hidden class
            // TODO: take this out -- have dropdown menu include hidden, then toggle with open
            $content.addClass('hide');

            return $content;

        }

        /**
         * Note: should only call when in DOM, otherwise will be off
         * Could cache if not 0 ( ? ... old TODO item )
         */
        function getDDWidth() {
            return ddDimension();
        }

        function getDDHeight() {
           return ddDimension(1);
        }

        /* default is width */
        function ddDimension(isHeight) {
            var container = settings.container;
            !container.jquery && (container = $(container));

            return $dd.is(':visible')
                ? $dd['outer' + (isHeight ? 'Height' : 'Width')]()
                : $dd.getHiddenElementDimensions({
                    $container: container && container.is(':visible') ? container : null
                    })[(isHeight ? 'height' : 'width')];
        }

        /*
         *  Apply a max width to the size of the dropdown.
         *  Use Case: a value in the select dropdown could be very long.
         *  Quickly put in for one use case and only tested on 'isSelect' (so limiting to that) --- could later expand & clean functionality.
         *  Better markup may also be a better answer.
         *  If want to get fancier, can only apply if the size would exceed the content ...
         *  Much could also be accomplished with CSS overrides.
         *   If start uses this in more places, take a look at doing this (... this plugin is already a mess).
         * */
        function applyMaxWidthToSelectDropdown() {

            // Accept pixel and integer values
            settings.maxWidth = parseFloat(settings.maxWidth);

            $opener.css({
                'max-width': settings.maxWidth,
                overflow: 'hidden'
            });

            // Set this on the individual menu items (as opposed to the container) so text doesn't cover the 'dropdown icon' on the right.
            $opener.find('.ddValue').css({
                'max-width': settings.maxWidth - 30,
                display: 'inline-block', // maybe should be hardcoded in CSS anyway ?
                overflow: 'hidden',
                'text-overflow': 'ellipsis'
            });

            $dd.css({
                'max-width': settings.maxWidth
            });

            $dd.find('.mi').each( function() {
                $(this).css({
                    overflow: 'hidden',
                    'text-overflow': 'ellipsis'
                });
            });
        }


        this.getDDEl = function() {
            return $dd;
        };



        this.destroy = function() {

            if (hasSubMenubars) {
                closeSubMenus();
                $subMenubars.off();
            }

            if (settings.applyIframeShim && $.fn.iframeShim)
                $dd.iframeShim('destroy'); /* must do b/f dd remove */

            //TODO: header if also if 'switched' by content wr?
            $dd.remove(); //this is where the majority of leak comes from in destroy
            $opener.remove(); //smaller leak here -- though when continue will still get leak ...

            /* remove references that could be help in wrapper views */
            $dd = null;
            $opener = null;

            $('body').off('click', close);
            $win.off('resize', position).off('scroll', close);
        };

        return this;
    };



}(jQuery, Mousetrap, _));


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/plugin/dropdown.js
 ** module id = 434
 ** module chunks = 0
 **/